<script lang="ts">
  import LogoAllCapsShort, {
    type LogoAllCapsShortProps,
  } from './icon/specials/LogoAllCapsShort.svelte';

  let props: LogoAllCapsShortProps = $props();
</script>

<LogoAllCapsShort {...props} />
